<app-card title="">
  <div title
    class="inventory_ctrl xs:flex xs:justify-start xs:content-start xs:items-start flex flex-row justify-between content-center items-center">
    <h5 class="ucase m-0 text-primaryblue xs:basis-full basis-1/2" tabindex="0">COMMON DRUG DATABASE MANAGEMENT V3.0.3
    </h5>

  </div>
  <section class="main-section">
    <div class="sticky_search">
      <div class="p-16 bg-white">
        <div
          class="flex justify-between content-center items-center xs:flex xs:flex-col sm:flex sm:flex-row md:flex md:flex-row lg:flex lg:flex-row">
          <!-- In your template file -->
          <div class="search-component">
            <div class="search-wrapper">
              <div class="search-input-section">
                <app-icon icon="search" class="icon_search"></app-icon>
                <input
                  class="search-input"
                  [ngModel]="searchText"
                  (ngModelChange)="onSearchTextChange($event)"
                  [placeholder]="'Search by ' + (selectedSearchCriteria?.label || 'Drug Name')"
                  id="searchcustomers-input"
                  size="20"
                  style="width: 120px"
                >
                <div *ngIf="validationError" class="validation-error">
                  {{ validationError }}
                </div>
              </div>
              <div class="separator"></div>
                <button mat-button class="dropdown-button"
                [matMenuTriggerFor]="menu"
                [ngStyle]="{'font-size': (selectedSearchCriteria?.label?.length > 10) ? '0.70rem' : '0.85rem'}">
                {{selectedSearchCriteria?.label || 'Drug Name'}}
                <mat-icon>expand_more</mat-icon>
                </button>
            </div>
          </div>

          <mat-menu #menu="matMenu" class="custom-menu">
            <button mat-menu-item *ngFor="let criteria of searchCriteria" (click)="onCriteriaSelect(criteria)">
              {{criteria.label}}
            </button>
          </mat-menu>


          <!-- <div class="search-wrapper" style="padding: 9px"> -->
          <!-- <div class="search-container">
              <app-icon icon="search" class="icon_search"></app-icon>
              <input class="search-input" inputId="searchcustomers-input"
              [(ngModel)]="searchText"
              (ngModelChange)="updateSearchWizard()"
                minLengthToSearch="1" placeholder="Scan or search by Drug Number, Drug Name or UPC"
                [(ngModel)]="searchText" id="search_customers">
            </div> -->
          <!-- </div> -->

          <div class="flex justify-between items-start w-full overflow-x-auto">
              <!-- <div class="basis-[20%] flex">
              <mat-form-field appearance="outline" class="search-criteria-select">
              <mat-select [(ngModel)]="selectedSearchCriteria" (selectionChange)="onSearchCriteriaChange()">
                <mat-option *ngFor="let criteria of searchCriteria" [value]="criteria.value">
                {{criteria.label}}
                </mat-option>
              </mat-select>
              </mat-form-field>
            </div> -->
            <!-- Left: Dropdowns -->
            <div class="flex flex-wrap gap-4 flex-grow min-w-0">    

              <!-- Data Source -->
              <div class="flex items-center gap-2 w-[240px] min-w-0 mr-[10px]">
                <label class="text-sm text-gray-700 whitespace-nowrap w-[100px]" for="dataSourceSelect">Data Source</label>
                <mat-form-field class="flex-1 min-w-0" appearance="fill">
                  <mat-select
                    id="dataSourceSelect"
                    [(ngModel)]="dataSourceId"
                    (selectionChange)="updateSearchWizard()"
                    ngDefaultControl
                  >
                    <mat-option *ngFor="let data of listOfDataSourceFilter" [value]="data.key">
                      {{ data?.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Country -->
              <div class="flex items-center gap-2 w-[220px] min-w-0 mr-[10px]">
                <label class="text-sm text-gray-700 whitespace-nowrap w-[80px]" for="countrySelect">Country</label>
                <mat-form-field class="flex-1 min-w-0" appearance="fill">
                  <mat-select
                    id="countrySelect"
                    [(ngModel)]="countryId"
                    (selectionChange)="updateSearchWizard()"
                    ngDefaultControl
                  >
                    <mat-option *ngFor="let data of listOfCountry" [value]="data.key">
                      {{ data?.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Modified By -->
              <div class="flex items-center gap-2 auto-width min-w-0 mr-[10px]">
                <label class="text-sm text-gray-700 whitespace-nowrap w-[100px]" for="modifiedBySelect">Modified By</label>
                <mat-form-field class="flex-1 auto-width" appearance="fill">
                  <mat-select
                    id="modifiedBySelect"
                    [(ngModel)]="modifiedBy"
                    [matTooltip]="modifiedBy"
                    matTooltipPosition="above"
                    (selectionChange)="updateSearchWizard()"
                    ngDefaultControl
                    data-testclass="select-modifiedby-drug-list"
                  >
                    <mat-option
                      *ngFor="let item of listOfModifiers"
                      [value]="item"
                      data-testclass="option-modifiedby-drug-list"
                    >
                      {{ item }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- QReason -->
              <div class="flex items-center gap-2 auto-width min-w-0 mr-[10px]">
                <label class="text-sm text-gray-700 whitespace-nowrap w-[80px]" for="qReasonSelect">QReason</label>
                <mat-form-field class="flex-1 auto-width" appearance="fill">
                  <mat-select
                    id="qReasonSelect"
                    [(ngModel)]="qReasonId"
                    (selectionChange)="updateSearchWizard()"
                    ngDefaultControl
                  >
                    <mat-option
                      *ngFor="let data of listOfQReason"
                      [value]="data.value"
                    >
                      {{ data.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Case Owner -->
              <div class="flex items-center gap-2 auto-width min-w-0 mr-[10px]">
                <label class="text-sm text-gray-700 whitespace-nowrap w-[100px]" for="caseOwnerSelect">Case Owner</label>
                <mat-form-field class="flex-1 auto-width" appearance="fill">
                  <mat-select
                    id="caseOwnerSelect"
                    [(ngModel)]="selectedCaseOwner"
                    [matTooltip]="selectedCaseOwner"
                    matTooltipPosition="above"
                    (selectionChange)="onCaseOwnerSelectionChange(selectedCaseOwner)"
                    ngDefaultControl
                  >
                    <mat-option *ngFor="let data of listOfCaseOwnersForFilter" [value]="data">
                      {{ data }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Hide Permanent Quarantine -->
               <div class="flex items-center gap-2 w-[320px] min-w-0">
                <label class="text-sm text-gray-700 whitespace-nowrap w-[180px]" for="permanentQuarantineSelect">Hide Permanent Quarantine</label>
                <mat-form-field class="flex-1 min-w-0" appearance="fill">
                  <mat-select
                    id="permanentQuarantineSelect"
                    [(ngModel)]="permanentQuarantineValue"
                    (selectionChange)="updateSearchWizard()"
                    ngDefaultControl
                  >
                    <mat-option *ngFor="let data of permanentQuarantine" [value]="data.value">
                      {{ data?.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

            </div>

            <!-- Right: Buttons -->
            <div class="flex gap-2 items-center shrink-0 w-[300px] justify-end">
              <button
                *ngIf="listOfCountry.length > 0"
                matTooltip="Add New Drug"
                class="btn-blue px-4 py-2 text-sm w-[140px]"
                (click)="openImportWizardNewWizardDrug()"
              >
                Add New Drug
              </button>

              <button
                *ngIf="listOfCountry.length > 0"
                class="btn-danger px-4 py-2 text-sm w-[140px]"
                (click)="openImportWizardFileUpload()"
              >
                Advance
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>


    <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8 main-table">
      <ng-container  matColumnDef="name">
        <th  mat-header-cell *matHeaderCellDef width="30%"> </th>
        <td mat-cell *matCellDef="let element" width="30%">
          <span style="font-weight: bold;">
            <span *ngIf="element.isExpanded">
              <mat-icon class="cross-wizard" style="cursor: pointer;">
                <img src="/assets/img/icons/ico.16.arwup.svg" alt="">
              </mat-icon>
            </span>
            <span *ngIf="!element.isExpanded">
              <mat-icon class="cross-wizard" style="cursor: pointer;">
                <img src="/assets/img/icons/ico.16.arwdown.svg" alt="">
              </mat-icon>
            </span>
            {{ element.name === 'SEARCH RESULTS' ?
            (element.name + ' (' + searchResultsCount + ')') :
            (element.name === 'QUARANTINED' ?
            (element.name + ' (' + QuarantineResultsCount + ')') :
            element.name)
            }}
          </span>          
        </td>
      </ng-container>
      <ng-container  matColumnDef="ndc">
        <th  mat-header-cell *matHeaderCellDef width="10%"> </th>
        <td mat-cell *matCellDef="let element" width="10%"> {{element.ndc}} </td>
      </ng-container>
      <ng-container   matColumnDef="countryCode">
        <th  mat-header-cell *matHeaderCellDef width="10%"> </th>
        <td mat-cell *matCellDef="let element" width="10%"> {{element.countryCode}} </td>
      </ng-container>
      <ng-container   matColumnDef="source">
        <th  mat-header-cell *matHeaderCellDef width="10%"> </th>
        <td mat-cell *matCellDef="let element" width="10%"> {{element.source}} </td>
      </ng-container>
      <ng-container   matColumnDef="system">
        <th  mat-header-cell *matHeaderCellDef width="10%"> </th>
        <td mat-cell *matCellDef="let element" width="10%"> {{element.system}} </td>
      </ng-container>
      <ng-container   matColumnDef="strength">
        <th  mat-header-cell *matHeaderCellDef width="10%"> </th>
        <td mat-cell *matCellDef="let element" width="10%"> {{element.strength}} </td>
      </ng-container>
      <ng-container   matColumnDef="manufacturer">
        <th  mat-header-cell *matHeaderCellDef width="10%"> </th>
        <td mat-cell *matCellDef="let element" width="10%"> {{element.manufacturer}} </td>
      </ng-container>
      <ng-container   matColumnDef="priority">
        <th  mat-header-cell *matHeaderCellDef width="10%"> </th>
        <td mat-cell *matCellDef="let element" width="10%"> {{element.priority}} </td>
      </ng-container>
      <ng-container   matColumnDef="modifiedBy">
        <th  mat-header-cell *matHeaderCellDef width="15%" data-testclass = "header-modifiedby-druglist"> </th>
        <td mat-cell *matCellDef="let element" width="15%" data-testclass = "cell-modifiedby-druglist"> {{element.modifiedBy}} </td>
      </ng-container>
      <ng-container   matColumnDef="requestor">
        <th  mat-header-cell *matHeaderCellDef width="10%"> </th>
        <td mat-cell *matCellDef="let element" width="10%"> {{element.requestor}} </td>
      </ng-container>
      <ng-container   matColumnDef="age">
        <th  mat-header-cell *matHeaderCellDef width="10%"> </th>
        <td mat-cell *matCellDef="let element" width="10%"> {{element.age}} </td>
      </ng-container>
      <ng-container   matColumnDef="action">
        <th  mat-header-cell *matHeaderCellDef width="5%"> </th>
        <td mat-cell *matCellDef="let element" width="5%"> {{element.action}} </td>
      </ng-container>
      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" style="padding:0px" [attr.colspan]="columnsToDisplay.length">
          <div class="row queue-element-detail"
            [@detailExpand]="(element.isExpanded) ? 'expanded' : 'collapsed'">

            <div
              *ngIf="element.name.split('(')[0].trim()==='SEARCH RESULTS'"
              style=" padding-bottom: .8rem;">
              <app-search-drug-list [dataSourceId]="dataSourceId" [searchText]="searchText"
                [permanentQuarantine]="permanentQuarantineValue" [countryId]="countryId"
                [selectedSearchCriteria]="selectedSearchCriteria" [modifiedBy]="modifiedBy"
                (countUpdated)="handleSearchCountUpdate($event)"></app-search-drug-list>
            </div>
            <div *ngIf="element.name.split('(')[0].trim()==='LAST MODIFIED RECORD'" style=" padding-bottom: .8rem;">
              <app-new-drug-list [dataSourceId]="dataSourceId" [selectedSearchCriteria]="selectedSearchCriteria"
                [searchText]="searchText" [permanentQuarantine]="permanentQuarantineValue" [modifiedBy]="modifiedBy"
                [countryId]="countryId"></app-new-drug-list>
            </div>
            <div *ngIf="element.name.split('(')[0].trim()==='DRUG CLASSIFICATION REQUEST'">
               <app-dcr-drug-list [caseOwner]="selectedCaseOwner" (countUpdated)="handleDcrCountUpdate($event)"></app-dcr-drug-list>
            </div>
            <div
              *ngIf="element.name.split('(')[0].trim()==='QUARANTINED'">
              <app-quarantined-drug-list [dataSourceId]="dataSourceId" [searchText]="searchText"
                [permanentQuarantine]="permanentQuarantineValue" [countryId]="countryId" [qReasonId]="qReasonId"
                [selectedSearchCriteria]="selectedSearchCriteria" [modifiedBy]="modifiedBy"
                (countUpdated)="handleQuarantineCountUpdate($event)"></app-quarantined-drug-list>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="queue-element-row"
        [class.queue-expanded-row]="element.isExpanded" (click)="element.isExpanded = !element.isExpanded;"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="queue-detail-row"></tr>


    </table>
    <table class="no-result" *ngIf="dataSource.data.length==0">
      <tr>
        <td [attr.colspan]="columnsToDisplay.length" style="text-align: center; padding:1rem;">
          <span>No results found</span>
          <br>
          <a (click)="openImportWizardNewDrug()">Add New Drug ></a>
        </td>
      </tr>

    </table>

  </section>
</app-card>
